// eslint-disable-next-line
import React from 'react';
import { PageSize, IPageSizeProps } from '@cb/apricot-react';

export default function PageSizeWrapper(props: IPageSizeProps) {
  return <PageSize {...props} />;
}
